export default {
    oldpassword_label: '旧密码',
    newpassword_label: '新密码',
    confirmpassword_label: '确认新密码',
    title_pwd: '修改密码',
    confirm_btn: '确定',
    return_btn: '返回',
    oldpassword_placeholder: '请输入您的旧密码',
    newpassword_placeholder: '请输入您的新密码',
    confirmpassword_placeholder: '请再次输入您的新密码',
    title_info: '修改个人资料',
    nickname_label: '昵称',
    email_label: '邮箱',
    mobile_label: '手机号',
    nickname_placeholder: '请输入您的昵称',
    email_placeholder: '请正确输入您的邮箱',
    mobile_placeholder: '请正确输入您的手机号'
  }


// WEBPACK FOOTER //
// ./src/i18n/zh-cn/modifyInfo.js